export enum FeatureFlag {
  ExcludeFloater = 'exclude_floater',
  AllowAiDownload = 'allow_ai_download',
}

export function useHasFeature(flag: FeatureFlag, userFeatures: string[]): boolean {
  return userFeatures?.includes(flag)
}
